module.exports = __webpack_public_path__ + "img/elektrophile-substitution.6d359541.jpg";